import { FormControl, InputLabel, MenuItem, Select, SelectChangeEvent } from '@mui/material'
import { OperationType } from '@operations/app/api'
import {
  EquipmentOperatorLandingFormData,
  EquipmentOperatorLandingUIStore,
} from '@operations/features/equipmentOperator/stores/equipment-operator-landing.ui-store'
import { useTranslate } from '@tolgee/react'
import { observer } from 'mobx-react-lite'
import { Controller, useFormContext } from 'react-hook-form'

interface Props {
  uiStore: EquipmentOperatorLandingUIStore
}

export const SelectOperationType = observer(({ uiStore }: Props) => {
  const { t } = useTranslate()

  const { control } = useFormContext<EquipmentOperatorLandingFormData>()

  return (
    <Controller
      control={control}
      name={'operationType'}
      render={({ field: { onChange, value } }) => (
        <FormControl fullWidth>
          <InputLabel>{t('process', 'Process')}</InputLabel>
          <Select
            label={t('process', 'Process')}
            value={value ?? 'All'}
            onChange={(event: SelectChangeEvent) =>
              onChange(event.target.value === 'All' ? null : (event.target.value as OperationType))
            }
            data-cy='operator-select-process-field'
          >
            <MenuItem value='All' data-cy='operator-select-process-option'>
              {t('all', 'All')}
            </MenuItem>
            <MenuItem value={OperationType.Inbound} data-cy='operator-select-process-option'>
              {t('discharge', 'Discharge')}
            </MenuItem>
            <MenuItem value={OperationType.Outbound} data-cy='operator-select-process-option'>
              {t('load', 'Load')}
            </MenuItem>
          </Select>
        </FormControl>
      )}
    />
  )
})
